import request from 'utils/request';

export async function getCostCompositions(params) {
  return request({
    url: '/cost/compositions',
    method: 'get',
    data: params,
  });
}

export async function setCostCompositions(params) {
  return request({
    url: '/cost/compositions',
    method: 'put',
    data: params,
  });
}

export async function getMaterialNorms(params) {
  return request({
    url: '/cost/material-norms',
    method: 'get',
    data: params,
  });
}

export async function getFinishedGoodCosts(params) {
  return request({
    url: '/cost/finished-goods',
    method: 'get',
    data: params,
  });
}

export async function getSaleCosts(params) {
  return request({
    url: '/cost/sales',
    method: 'get',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/services/cost.js